import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {Tab} from '@models/tab';

@Injectable({
    providedIn: 'root'
})
export class TabService {

    /**
     * Mock from API
     */
    getTab(slug): Observable<Tab> {
        const str = localStorage.getItem('lybox_tab_' + slug);
        if (str === '' || str === null) {
            return of(null);
        }
        const tab = JSON.parse(str) as Tab;

        return of(tab);
    }

    updateTab(slug, tab: Tab) {
        localStorage.setItem('lybox_tab_' + slug, JSON.stringify(tab));
    }
}

